
import Carousel from "~/components/global/Carousel";
import Breadcrumbs from "~/components/global/Breadcrumbs";
import ClaimsSupport from "~/components/global/ClaimsSupport";
export default {
    spacingDebug: true,
    components: {
        Carousel,
        Breadcrumbs,
        ClaimsSupport,
        Accordion: () => import("~/components/global/Accordion"),
        FileAClaim: () => import("~/components/global/FileAClaim"),
    },
    props: {
        payload: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    data: ({ $route }) => ({
        routeSlug: $route.params?.slug,
        bannerTemplatePayload: {
            isReady: false,
            hasBreadcrumb: true,
            hasLeaveConfirmation: true,
            themeData: {
                isDarkMode: false,
                backgroundColor: "#1F5295",
                fontColor: "#FFF",
            },
            imageData: {
                desktop: {
                    id: "mico-r0s1t2",
                    format: "webp",
                    src: "/assets/defaults/mico-banner-[light].webp",
                    alt: "Sitewide Breadcrumbs for Desktop",
                },
                mobile: {
                    id: "mico-o7p8q9",
                    format: "webp",
                    src: "/assets/defaults/mico-banner-[light].webp",
                    alt: "Sitewide Breadcrumbs for Mobile",
                },
            },
            ctaData: {
                headerData: {
                    title: "",
                    description: "",
                },
                hasCtaButton: true,
                isScrollToAnchor: true,
                isInfoBannerVisible: true,
                isExternalLink: false,
                label: "See More",
                link: "#",
            },
        },
        claims: [
            {
                title: "Claim Process",
                description: "File your insurance claim through our digital claim process.",
                url: "/claims-and-support/claim-process#claim-process",
                image: "/assets/icons/claim-process-[light].webp",
            },
            {
                title: "Claim Forms",
                slug: "claim-form",
                description: "Download necessary forms and documents to assist you with your insurance claims.",
                url: "/claims-and-support/claim-forms#claim-forms",
                image: "/assets/icons/claim-forms-[light].webp",
            },
            {
                title: "FAQs",
                description: "Know more about our products, offerings, and processes.",
                url: "/claims-and-support/faqs#brochures",
                image: "/assets/icons/faq-[light].webp",
            },
        ],
        claimsProcess: [],
        claimForms: [],
        claimsFaqs: [],
    }),
    computed: {
        fileAClaimContent() {
            return {
                heading: {
                    level: "h2",
                    textContent: "Got some claims?",
                    alignment: "center",
                },
                cta: {
                    url: "/claims-and-support/claims-form",
                    textContent: "File and Submit an Online Claim Form",
                },
            };
        },
        carouselContent() {
            const banner = this.bannerTemplatePayload;
            if (!banner.isReady) return [];
            const cta = banner.ctaData;
            const visible = [true, 1, "1"].includes(cta.isInfoBannerVisible);
            return [
                {
                    id: "claims-banner",
                    title: visible ? cta.headerData.title : "",
                    info_banner_position: cta.infoBannerPosition || "center",
                    cta_btn_label: visible ? cta.label : "",
                    link: cta.link,
                    is_anchor: true,
                    tracking: { cta_action: "scroll-down", cta_location: "Banner" },
                    images: [
                        { category: "image", path: banner.imageData.desktop.src, alt: cta.headerData.title || "Claims and Support" },
                        { category: "image_mobile", path: banner.imageData.mobile.src, alt: cta.headerData.title || "Claims and Support" },
                    ],
                },
            ];
        },
        claimsSupportContent() {
            return {
                heading: { level: "h2", textContent: "Claims and Support", alignment: "center" },
                body: {
                    items: this.claims.map((item) => ({
                        heading: { level: "h3", textContent: item.title, alignment: "center" },
                        body: { textContent: item.description, alignment: "center" },
                        thumbnail: { image: { src: item.image, alt: item.title, url: item.url } },
                    })),
                },
            };
        },
    },
    methods: {
        accordionPayload(title, items) {
            return {
                title,
                items: (Array.isArray(items) ? items : []).filter(Boolean).map((item, index) => ({
                    key: index,
                    title: item.title,
                    html: item.description && item.description !== "NA" ? item.description : item.original?.content || "",
                    files: item.files,
                })),
            };
        },
        initialize() {
            this.initializeBannerTemplate();
            this.claimsProcess = this.mutateClaimsProcess();
            this.claimForms = this.mutateClaimsForms();
            this.claimsFaqs = this.mutateClaimsFaqs();
        },
        initializeBannerTemplate() {
            const hero = this.payload?.hero?.[0];
            if (!hero) return;
            const desktopImage = (Array.isArray(hero.images) ? hero.images : []).find((img) => img?.category === "image" && img.type === "page_banner");
            const mobileImage = (Array.isArray(hero.images) ? hero.images : []).find((img) => img?.category === "image_mobile" && img.type === "page_banner");
            this.bannerTemplatePayload = {
                ...this.bannerTemplatePayload,
                isReady: true,
                themeData: {
                    ...this.bannerTemplatePayload.themeData,
                    backgroundColor: hero.themeColor,
                },
                imageData: {
                    ...this.bannerTemplatePayload?.imageData,
                    desktop: {
                        ...this.bannerTemplatePayload.imageData.desktop,
                        src: desktopImage?.path ?? "/assets/defaults/mico-banner-[light].webp",
                    },
                    mobile: {
                        ...this.bannerTemplatePayload.imageData.mobile,
                        src: mobileImage?.path ?? "/assets/defaults/mico-banner-[light].webp",
                    },
                },
                ctaData: {
                    ...this.bannerTemplatePayload?.ctaData,
                    headerData: {
                        ...this.bannerTemplatePayload.ctaData.headerData,
                        title: hero.title,
                        description: null,
                    },
                    infoBannerPosition: hero.info_banner_position ?? "center",
                    isInfoBannerVisible: hero.is_info_banner_visible ?? false,
                    isExternalLink: false,
                    isScrollToAnchor: true,
                    link: "#file-a-claim",
                    label: "File a Claim",
                },
            };
        },
        mutateClaimsProcess() {
            const claimsProcess = this.payload?.claimsProcess || [];
            const claimsArray = Array.isArray(claimsProcess) ? claimsProcess : [claimsProcess];
            const claimsProcessMutated = claimsArray.map((item) => {
                return {
                    title: item.name || "Untitled",
                    description: item.description || "NA",
                    files: item.file_path
                        ? [
                              {
                                  name: item.file_name || "Unknown",
                                  file_path: item.file_path,
                                  file_size: item.file_size || "",
                                  file_type: item.file_type || "",
                              },
                          ]
                        : item.files || [],
                    original: item,
                };
            });
            return claimsProcessMutated;
        },
        mutateClaimsForms() {
            const claimsForms = this.payload?.claimsForms || [];
            const claimsArray = Array.isArray(claimsForms) ? claimsForms : [claimsForms];
            const claimsFormsMutated = claimsArray.map((item) => {
                return {
                    title: item.name || "Untitled",
                    description: item.description || "NA",
                    files: item.file_path
                        ? [
                              {
                                  name: item.file_name || "Unknown",
                                  file_path: item.file_path,
                                  file_size: item.file_size || "",
                                  file_type: item.file_type || "",
                              },
                          ]
                        : item.files || [],
                    original: item,
                };
            });
            return claimsFormsMutated;
        },
        mutateClaimsFaqs() {
            const claimsFaqs = this.payload?.claimsFaqs || {};
            if (typeof claimsFaqs !== "object" || Array.isArray(claimsFaqs)) {
                return {};
            }
            const mutated = {};
            Object.keys(claimsFaqs).forEach((group) => {
                const faqs = Array.isArray(claimsFaqs[group]) ? claimsFaqs[group] : [];

                mutated[group] = faqs.map((item) => ({
                    title: item.question || item.name || "Untitled",
                    description: item.answer || item.description || "NA",
                    files: item.file_path
                        ? [
                              {
                                  name: item.file_name || "Unknown",
                                  file_path: item.file_path,
                                  file_size: item.file_size || "",
                                  file_type: item.file_type || "",
                              },
                          ]
                        : item.files || [],
                    original: item,
                }));
            });
            return mutated;
        },
    },
    watch: {
        payload: {
            immediate: true,
            handler() {
                this.routeSlug = this.$route.params?.slug;
                this.initialize();
            },
        },
    },
};
